// The status line under a member's name on their Masterminds page when their access isn't active (the critique's
// admin 5), with the person page's own buttons, so a payment or a pause is dealt with where Adam works on the member:
//   "Overdue: payment failed 25 Sep. Suspended from 2 Oct unless paid."  [Send card link] [Give 7 more days]
//   "Suspended since 2 Oct, unpaid"  [Send card link]
//   "Paused by you until 15 Nov"  [Resume now]
// The writes are the person page's (src/admin/people/AccessCard.jsx: the card link, 7 more days, and Resume now's
// form), from the access row and its billing as the person page reads them. A pause Stripe set says so, with no button:
// Adam pauses and resumes those in Stripe, which the hub follows.
import { useState } from 'react'
import { Button } from '../ui/index.js'
import { CHANGE, PERSON, boardDay } from '../people/words.js'
import { canSendCard, giveSevenDays, sendCardLink } from '../people/AccessCard.jsx'
import { statusLine } from './section.js'
import { MM } from './words.js'

export function StatusLine({ api, row, billing, hasCustomer, sum, personId, first, onOpen, onDone }) {
  const [busy, setBusy] = useState(null)
  const [sent, setSent] = useState(false)
  // the day 7 more days runs to, once given: the button says so and can't be pressed again, as on the person page
  const [extended, setExtended] = useState(null)
  const [problem, setProblem] = useState(null)
  const status = statusLine(row, sum)
  if (!status) return null
  const card = (row.status === 'overdue' || row.status === 'suspended') && canSendCard(billing, hasCustomer)
  const grace = row.status === 'overdue' && Boolean(row.suspend_on)
  const resume = row.status === 'paused' && row.paused_by === 'staff'

  async function act(kind, fn) {
    if (busy) return
    setBusy(kind); setProblem(null)
    try {
      await fn()
    } catch (e) {
      setProblem(e.message)
    } finally {
      setBusy(null)
    }
  }

  return (
    <section className={`amx-status amx-status--${status.kind}`} aria-label={MM.statusLabel(first)}>
      <p className="amx-status-text">{status.text}</p>
      {(card || grace || resume) && (
        <span className="amx-row-actions">
          {card && (
            <Button size="sm" kind="ink" busy={busy === 'card'} disabled={sent} onClick={() => act('card', async () => {
              const answer = await sendCardLink(api, { personId, row })
              setSent(true)
              await onDone(answer?.message || PERSON.cardSent)
            })}>{sent ? PERSON.cardSent : PERSON.cardLink}</Button>
          )}
          {grace && (
            <Button size="sm" busy={busy === 'grace'} disabled={Boolean(extended)} onClick={() => act('grace', async () => {
              const day = boardDay(await giveSevenDays(api, row))
              setExtended(day)
              await onDone(CHANGE.done.grace(day))
            })}>{extended ? PERSON.extended(extended) : PERSON.extend}</Button>
          )}
          {resume && <Button size="sm" onClick={() => onOpen('resume')}>{CHANGE.resume}</Button>}
        </span>
      )}
      {problem && <p className="ad-error" role="alert">{problem}</p>}
    </section>
  )
}
